import { UserProps } from '@ninjacart/nc-nk-store';
import { Card, Paragraph, Text, View, XStack } from '@ninjacart/nc-nk-ui';
import { MapPin, Phone } from '@tamagui/lucide-icons';
import { useTranslation } from 'react-i18next';

const UserDetails = ({ userProfile }: { userProfile: UserProps }) => {
  const { t } = useTranslation();
  return (
    <XStack>
      <Card width={'100%'} marginVertical={2} padding={4} backgroundColor="$cardbackground">
        <View padding={15}>
          <Paragraph size={12} fontWeight={'400'} paddingBottom={3} color={'$grey'}>
            {t('page.yourDetails')}
          </Paragraph>
          {userProfile?.user?.primaryPhoneNumber && (
            <XStack alignItems="center" paddingBottom={3} space="$2">
              <Phone color="$color" size={14} />
              <Text fontSize={14} color="$color">
                {userProfile?.user?.primaryPhoneNumber}
              </Text>
            </XStack>
          )}
          {(userProfile?.user?.contactDetails?.address?.[0]?.district ||
            userProfile?.user?.contactDetails?.address?.[0]?.state) && (
            <XStack alignItems="center" space="$2">
              <MapPin color="$color" size={14} />
              <Text fontSize={14} color="$color">
                {`${userProfile?.user?.contactDetails?.address?.[0]?.district ?? ''}, ${
                  userProfile?.user?.contactDetails?.address?.[0]?.state ?? ''
                }`.trim()}
              </Text>
            </XStack>
          )}
        </View>
      </Card>
    </XStack>
  );
};

export default UserDetails;
